import {
  MARKETING_CONSENT_EVENT,
  readMarketingConsent,
} from "@/components/analytics/consent";
import { useLocation } from "@tanstack/react-router";
import { useEffect, useRef, useState } from "react";

const GA_ID = "G-Q2K575TNPJ";
const GOOGLE_ADS_ID = "AW-16798392352";

function initializeGoogle() {
  if (window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = (...args: unknown[]) => window.dataLayer?.push(args);
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
  window.gtag("config", GOOGLE_ADS_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export function GoogleAnalytics() {
  const location = useLocation();
  const [enabled, setEnabled] = useState(false);
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    const sync = () => setEnabled(readMarketingConsent() === "granted");
    sync();
    window.addEventListener(MARKETING_CONSENT_EVENT, sync);
    return () => window.removeEventListener(MARKETING_CONSENT_EVENT, sync);
  }, []);

  useEffect(() => {
    if (!enabled || import.meta.env.DEV) return;
    initializeGoogle();
  }, [enabled]);

  useEffect(() => {
    if (!enabled || import.meta.env.DEV || !window.gtag) return;
    const path = `${location.pathname}${location.searchStr}${location.hash}`;
    if (previousPath.current === path) return;
    previousPath.current = path;
    window.gtag("event", "page_view", {
      page_location: window.location.href,
      page_path: path,
      page_title: document.title,
    });
  }, [enabled, location.hash, location.pathname, location.searchStr]);

  return null;
}

declare global {
  interface Window {
    dataLayer?: unknown[][];
  }
}
